
// utils/timeUtils.js
/**
 * Format arrival time to HH:MM
 * Adjusts for Peru timezone (UTC-5)
 */
export function formatArrivalTime(arrivalTime) {
  if (!arrivalTime) return '';
  
  const date = new Date(arrivalTime);
  
  // Adjust for Peru timezone (UTC-5)
  date.setHours(date.getHours() - 5);
  
  const hours = date.getHours().toString().padStart(2, '0');
  const minutes = date.getMinutes().toString().padStart(2, '0');
  
  return `${hours}:${minutes}`;
}